export function agruparEvolucionDeudas(registros, tipo) {
  const grupos = new Map()
  const columna = tipo.toLowerCase()

  for (const registro of registros) {
    // El reporte usa AAAAMMDD; también admite fechas AAAA-MM-DD.
    const fecha = String(registro.fechareporte ?? "").match(/^(\d{4})[-/]?(\d{2})(?:[-/]?\d{2})?$/)
    const etiqueta = String(registro.mes ?? "").trim().replace(/\./g, "").toUpperCase()
    const monto = Number(registro[columna])
    if (!fecha || !etiqueta || Number(fecha[2]) < 1 || Number(fecha[2]) > 12 ||
        registro[columna] == null || String(registro[columna]).trim() === "" || !Number.isFinite(monto)) {
      throw new Error("La información de evolución de deudas no tiene un formato válido.")
    }

    const mes = Number(fecha[1]) * 12 + Number(fecha[2]) - 1
    if (!grupos.has(mes)) grupos.set(mes, { mes: etiqueta, monto: 0, entidades: new Map() })
    const grupo = grupos.get(mes)
    grupo.monto += monto
    if (registro.entidad) {
      const entidad = String(registro.entidad)
      grupo.entidades.set(entidad, (grupo.entidades.get(entidad) || 0) + monto)
    }
  }

  return Array.from(grupos)
    .sort(([a], [b]) => a - b)
    .slice(-24)
    .map(([, grupo]) => ({
      mes: grupo.mes,
      monto: grupo.monto,
      entidades: Array.from(grupo.entidades, ([entidad, monto]) => ({ entidad, monto })),
    }))
}
